// Zalso · Geldrechnung. DIE eine Stelle, über die jede Position und jede Summe läuft.
// Regeln (Entscheidung 11.08.2026):
//   - innen ausschließlich ganze Cent, kein Float-Zwischenergebnis
//   - genau eine kaufmännische Rundung pro Position bzw. pro Summenschritt
//   - Euro-Formatierung erst bei der Ausgabe (fmt)
// Gilt für Stück UND Gewicht, für Zwischensumme, Steueranteile, Rabatt, Trinkgeld, Rückgeld.
// Zweiter Rechenweg = Bonsumme hängt davon ab, wer zuletzt gerundet hat. Deshalb: nur dieser hier.
(function () {
  // kaufmännisch, symmetrisch (0,5 immer weg von der Null: gilt auch für Rabattzeilen)
  function roundHalfUp(n) { return n < 0 ? -Math.floor(-n + 0.5) : Math.floor(n + 0.5); }
  function toCents(eur) { return roundHalfUp(Number(eur || 0) * 100); }
  function fromCents(c) { return (c || 0) / 100; }
  function fmt(c) { return (Math.abs(c || 0) / 100).toFixed(2).replace(".", ",") + " €"; }
  function fmtSigned(c) { return ((c || 0) < 0 ? "− " : "") + fmt(c); }

  // ── Gewicht ────────────────────────────────────────────────────────────────
  // unitDivisor: 1000 bei €/kg, 100 bei €/100g. Die Waage gehört dem Wirt,
  // wir rechnen nur: Gramm kommen als Tastatureingabe.
  var DIV = { kg: 1000, "100g": 100 };
  function divisor(weightUnit) { return DIV[weightUnit] || 1000; }
  function netWeightG(grossWeightG, tareG) {
    return Math.max(0, Math.round(Number(grossWeightG) || 0) - Math.round(Number(tareG) || 0));
  }
  // Die Rechenstelle für Gewicht. Eine Rundung, kein Float-Zwischenschritt.
  function weightCents(pricePerUnitCents, weightUnit, netG) {
    return roundHalfUp((Number(pricePerUnitCents) || 0) * (Number(netG) || 0) / divisor(weightUnit));
  }
  // Eingabe-Prüfung für den Gramm-Dialog. Ein Ergebnis, damit jede Fläche dieselbe
  // Sperre und denselben Klartext zeigt: nie 0 €, unter keinen Umständen negativ.
  function checkWeightInput(grossWeightG, tareG) {
    var g = Math.round(Number(grossWeightG) || 0), t = Math.round(Number(tareG) || 0);
    if (g <= 0) return { ok: false, reason: "empty", text: "Gramm eintippen, dann übernehmen." };
    if (t > 0 && g <= t) return { ok: false, reason: "tare", text: "Gewicht muss über der Tara liegen (" + t + " g)." };
    return { ok: true, reason: null, text: null };
  }
  function quantityKg(netG) { return Math.round((Number(netG) || 0)) / 1000; } // 3 Dezimalen exakt
  function fmtWeight(netG) {
    var g = Math.round(Number(netG) || 0);
    return g >= 1000 ? (g / 1000).toFixed(3).replace(/0+$/, "").replace(/[.,]$/, "").replace(".", ",") + " kg"
                     : g + " g";
  }
  function fmtPerUnit(pricePerUnitCents, weightUnit) { return fmt(pricePerUnitCents) + "/" + (weightUnit || "kg"); }
  function isWeight(x) { return !!x && x.sellBy === "weight"; }

  // ── Positionen ─────────────────────────────────────────────────────────────
  // ÜBERGANGSSCHICHT für Demodaten (entfällt, sobald Preise nativ in Cent liegen).
  // Für den Build gilt: Preise sind in Datenmodell, API und Datenbank durchgehend
  // Integer-Cent; Euro-Kommazahlen gibt es nur noch in der Anzeige. Solange die alten
  // Kataloge `price: 8.5` führen, konvertiert toCents hier EINMAL mit Rundung
  // (Math.round(euro × 100)) — ohne die Rundung liefert Binär-Float bei Werten wie
  // 4,35 € einen Cent zu wenig.
  function unitCents(line) {
    if (!line) return 0;
    if (line.unitPriceCents != null) return Math.round(line.unitPriceCents);
    if (line.pricePerUnit != null) return Math.round(line.pricePerUnit);
    return toCents(line.price);
  }
  function lineNetG(line) {
    if (line.netWeightG != null) return Math.round(line.netWeightG);
    return netWeightG(line.grossWeightG, line.tareG);
  }
  function lineCents(line) {
    if (!line) return 0;
    if (isWeight(line)) return weightCents(unitCents(line), line.weightUnit || "kg", lineNetG(line));
    var q = line.qty == null ? 1 : line.qty;
    return unitCents(line) * q;
  }
  function sumCents(lines) { return (lines || []).reduce(function (s, l) { return s + lineCents(l); }, 0); }

  // Prozentwerte (Rabatt, Trinkgeld) und Rückgeld: gleiche Rundung, gleiche Einheit.
  function pctCents(baseCents, pct) { return roundHalfUp((baseCents || 0) * (Number(pct) || 0) / 100); }
  function changeCents(givenCents, totalCents) { return (givenCents || 0) - (totalCents || 0); }

  // USt-Aufteilung auf Bruttobeträgen. Rechtsstand ab 01.01.2026: Speisen 7 %,
  // Getränke 19 %. Rabatt-/Service-Zeilen (special) anteilig verteilen, damit die
  // Steuersumme exakt zum kassierten Betrag passt.
  function taxGroupsCents(lines) {
    var gross = {}, plain = 0, special = 0;
    (lines || []).forEach(function (l) {
      var g = lineCents(l);
      if (l.special) { special += g; return; }
      var r = l.taxRate || "19%";
      gross[r] = (gross[r] || 0) + g;
      plain += g;
    });
    return Object.keys(gross)
      .filter(function (r) { return parseFloat(r) > 0; })
      .sort(function (a, b) { return parseFloat(a) - parseFloat(b); })
      .map(function (r) {
        var g = gross[r];
        var adj = plain > 0 ? g + roundHalfUp(special * g / plain) : g;
        var rate = parseFloat(r) / 100;
        var net = roundHalfUp(adj / (1 + rate));
        return { rate: r, grossCents: adj, netCents: net, taxCents: adj - net };
      });
  }

  // ── Trinkgeld ───────────────────────────────────────────────────────────
  // Standard-Prozente 5/10/20 überall (Entscheidung 20.08., Glossar Rev. 25: die 15-%-Stufe
  // und die "glatter Euro"-Variante sind gestrichen, kein Aufrunden): eine Regel für volle
  // Zahlung, Teilzahlung und Gastdisplay. "Eigener Betrag" deckt eigene Wünsche ab. Betrag je
  // Kachel über die eine Rundung (pctCents); die harte 20-%-Kappe ist damit inhärent erfüllt.
  var TIP_PCTS = [5, 10, 20];
  function tipOptions(totalCents) {
    var t = Math.max(0, Math.round(totalCents || 0));
    return tipPresets(t).map(function (c) {
      return { cents: c, pct: t > 0 ? Math.round((c / t) * 100) : 0, label: fmt(c), pctLabel: (t > 0 ? Math.round((c / t) * 100) : 0) + " %" };
    });
  }
  function tipPresets(totalCents) {
    var t = Math.max(0, Math.round(totalCents || 0));
    if (t <= 0) return [];
    var out = [];
    for (var i = 0; i < TIP_PCTS.length; i++) {
      var c = pctCents(t, TIP_PCTS[i]);
      if (c > 0 && out.indexOf(c) === -1) out.push(c);
    }
    return out;
  }
  // Fragt die Kasse in diesem Verkaufsmodus überhaupt nach Trinkgeld? Es hängt am Modus,
  // nicht am Positionstyp: sonst kommt die Frage zurück, sobald der Konditor einen Tee
  // dazu verkauft (gemischter Bon, derselbe Thekenverkauf).
  var TIP_CHANNELS = { table: true, theke: false, schnellverkauf: false, kiosk: false, qr: true, shop: false };
  function tipAskDefault(channel, biz) {
    if (channel && TIP_CHANNELS[channel] !== undefined) return TIP_CHANNELS[channel];
    return biz === "restaurant" || biz === "cafe";     // Tisch-Service fragt, Theke nicht
  }
  // Wem das Trinkgeld zusteht. Arbeitnehmer-Trinkgeld läuft steuerfrei durch, Trinkgeld
  // an den Unternehmer ist Betriebseinnahme; DSFinV-K führt beides getrennt. Deshalb ein
  // eigenes Feld, keine Behauptung im Text. Fiskalische Behandlung: Fiskal-Spec.
  // Angestellte = Personen mit Rolle ungleich Inhaber. Eine Quelle, damit „employees"
  // nur bei echten Angestellten greift (Fiskal: steuerfrei durchlaufend vs. Betriebseinnahme).
  function staffCount(list) {
    return (list || []).filter(function (p) { return !/inhaber/i.test(p.role || p.rl || ""); }).length;
  }
  function tipRecipient(staffCount) { return (staffCount || 0) > 0 ? "employees" : "owner"; }
  function tipClaim(staffCount) {
    return tipRecipient(staffCount) === "employees"
      ? "Geht vollständig ans Team. Ganz freiwillig."
      : "Freiwillig, danke.";
  }

  // ── Kartenaufschlag (Surcharge) auf dem Beleg ─────────────────────────────
  // Zalso erhebt keinen Aufschlag: Viva erhebt ihn terminalseitig und nur bei Firmen- und
  // Nicht-EWR-Karten (§ 270a BGB macht ihn bei Verbraucherkarten unwirksam). Wir weisen ihn
  // nur aus — Belegzeile ab Tag 1 Pflicht. Der Betrag kommt später aus surchargeAmount der
  // Viva-Antwort (1796); demoCents ist der Prototyp-Wert, keine Rechnung.
  var SURCHARGE = {
    label: "Kartenaufschlag",
    note: "Von Viva erhoben, nur bei Firmen- und Nicht-EWR-Karten.",
    demoCents: 47,
    isCardPay: function (payLine) { return /karte|card|visa|master|giro/i.test(payLine || ""); },
    // Wer den Aufschlag tragen DARF: nur Firmenkarten und Nicht-EWR-Karten. § 270a BGB macht ihn
    // bei inländischen EU-Verbraucherkarten (girocard, private Visa/Mastercard aus dem EWR)
    // unwirksam — die Belegzeile darf dort nie erscheinen. Eine Stelle, alle Flächen fragen hier.
    isSurchargeable: function (payLine) {
      var s = String(payLine || "");
      return /business|corporate|commercial|firmenkarte/i.test(s) || /\b(non-?eea|us|uk|ch|tr)\b/i.test(s);
    },
  };

  // ── Datenregel: Gewicht geht nicht an Plattformen und nicht online ─────────
  // Ein Gewichtsartikel im Plattform-Export (Mergeport SetPosItems) würde einen
  // Preis verkaufen, den es zum Bestellzeitpunkt noch nicht gibt. Hier verankert,
  // nicht in der Ansicht: jede Exportstelle ruft das auf.
  // Gewicht hat keinen Mengen-Stepper und keine Teilmenge: zwei Portionen sind zwei
  // Wiegungen, also zwei Positionen. Bearbeiten heißt Gramm korrigieren, nie multiplizieren.
  function canStepQuantity(line) { return !isWeight(line); }
  function canSplitQuantity(line) { return !isWeight(line); }
  function isPlatformExportable(article) { return !isWeight(article); }
  function isOnlineSellable(article) { return !isWeight(article); }
  function forPlatformExport(articles) { return (articles || []).filter(isPlatformExportable); }
  function exportBlockedReason(article) {
    return isWeight(article) ? "Wird nicht an Lieferplattformen übertragen" : null;
  }

  // Beleg- und Bon-Beschriftung: Menge und Einheit gehören auf jede Position
  // (DSFinV-K führt die Menge je Position ohnehin).
  function qtyLabel(line) {
    if (isWeight(line)) return fmtWeight(lineNetG(line)) + " × " + fmtPerUnit(unitCents(line), line.weightUnit);
    return (line.qty == null ? 1 : line.qty) + "×";
  }

  // Selbsttest der Testfälle aus docs/Gewichtsartikel.md. Läuft beim Laden, meldet
  // sich nur bei Abweichung — so bleibt die Rechenstelle dauerhaft überprüfbar.
  function selftest() {
    var cases = [
      [2490, "kg", 375, 934], [2490, "kg", 1, 2], [1850, "kg", 1250, 2313], [250, "100g", 375, 938],
    ];
    var bad = cases.filter(function (c) { return weightCents(c[0], c[1], c[2]) !== c[3]; });
    if (bad.length) console.error("ZalsoMoney: Gewichtsrechnung weicht ab", bad);
    if (netWeightG(375, 400) !== 0) console.error("ZalsoMoney: Tara größer als Brutto muss 0 ergeben");
    // Tara >= Brutto wird abgewiesen (nie 0 €, nie negativ)
    if (checkWeightInput(8, 12).ok || checkWeightInput(12, 12).ok || checkWeightInput(0, 0).ok)
      console.error("ZalsoMoney: Tara-/Nullprüfung greift nicht");
    if (weightCents(250, "100g", netWeightG(8, 12)) !== 0) console.error("ZalsoMoney: Gewicht unter Tara darf nie einen Betrag ergeben");
    // Gewichtsposition hat keinen Mengen-Multiplikator: qty wird ignoriert
    var w = { sellBy: "weight", weightUnit: "kg", unitPriceCents: 2490, grossWeightG: 375, qty: 3 };
    if (lineCents(w) !== 934) console.error("ZalsoMoney: Gewichtsposition darf nicht mit qty multipliziert werden");
    // Storno/Split greifen nur auf ganze Positionen: Teilmenge einer Wiegung gibt es nicht
    if (canSplitQuantity(w) || canSplitQuantity({ sellBy: "weight" })) console.error("ZalsoMoney: Gewichtsposition ist atomar");
    if (!canSplitQuantity({ qty: 2, price: 3.5 })) console.error("ZalsoMoney: Stückposition muss teilbar bleiben");
    // Kanal-Opt-out (12.08.): der Default „alles online" darf die Gewichts-Sperre nie überstimmen.
    var wCh = { sellBy: "weight", weightUnit: "kg", pricePerUnit: 2490, ch: ["theke", "shop", "qr", "plattform"] };
    if (isPlatformExportable(wCh) || isOnlineSellable(wCh)) console.error("ZalsoMoney: Gewichtsartikel trotz Kanal-Default online/exportierbar");
    if (forPlatformExport([wCh, { n: "Tee", p: 350 }]).length !== 1) console.error("ZalsoMoney: forPlatformExport muss Gewichtsartikel filtern, egal welche Kanäle gesetzt sind");
    // Trinkgeld: Standard-Prozente 5/10/20 aus der einen Rundung, auch bei kleinen Beträgen
    var tp = tipPresets(466);
    if (tp.length !== 3 || tp[0] !== 23 || tp[1] !== 47 || tp[2] !== 93) console.error("ZalsoMoney: Trinkgeld muss 5/10/20 % liefern", tp);
    // Normale Bons dürfen keine Cent-Vorschläge liefern (Regression 11.08.): mind. 5 %
    var tp2 = tipPresets(5080);
    if (!tp2.length || tp2[0] < roundHalfUp(5080 * 0.05)) console.error("ZalsoMoney: Trinkgeld-Kachel unter 5 % bei normalem Bon", tp2);
    if (tp2.some(function (c) { return c > roundHalfUp(5080 * 0.2); })) console.error("ZalsoMoney: Trinkgeld-Kachel über 20 %", tp2);
    if (tp2.length !== 3) console.error("ZalsoMoney: normaler Bon braucht drei Kacheln (5/10/20 %)", tp2);
    if (tipAskDefault("theke") || tipAskDefault("schnellverkauf") || !tipAskDefault("table"))
      console.error("ZalsoMoney: Trinkgeld-Frage hängt am Verkaufsmodus");
    if (tipRecipient(0) !== "owner" || tipRecipient(3) !== "employees") console.error("ZalsoMoney: tipRecipient falsch");
    // Kartenaufschlag nur wo erlaubt: girocard und private EWR-Karten tragen ihn nie (§ 270a BGB)
    if (SURCHARGE.isSurchargeable("Karte · Girocard •••• 4791") || SURCHARGE.isSurchargeable("Karte · Visa Debit •••• 2288") || SURCHARGE.isSurchargeable("Bar"))
      console.error("ZalsoMoney: Aufschlag auf einer Verbraucherkarte ausgewiesen");
    if (!SURCHARGE.isSurchargeable("Karte · Visa Business •••• 0142") || !SURCHARGE.isSurchargeable("Karte · Mastercard · US •••• 6013"))
      console.error("ZalsoMoney: Aufschlag auf Firmen-/Nicht-EWR-Karte nicht erkannt");
  }

  window.ZalsoMoney = {
    surcharge: SURCHARGE,
    roundHalfUp: roundHalfUp, toCents: toCents, fromCents: fromCents, fmt: fmt, fmtSigned: fmtSigned,
    divisor: divisor, netWeightG: netWeightG, weightCents: weightCents, quantityKg: quantityKg,
    fmtWeight: fmtWeight, fmtPerUnit: fmtPerUnit, isWeight: isWeight,
    unitCents: unitCents, checkWeightInput: checkWeightInput,
    canStepQuantity: canStepQuantity, canSplitQuantity: canSplitQuantity, lineNetG: lineNetG, lineCents: lineCents, sumCents: sumCents,
    pctCents: pctCents, changeCents: changeCents, taxGroupsCents: taxGroupsCents,
    isPlatformExportable: isPlatformExportable, isOnlineSellable: isOnlineSellable,
    forPlatformExport: forPlatformExport, exportBlockedReason: exportBlockedReason,
    qtyLabel: qtyLabel, selftest: selftest,
    tipPresets: tipPresets,
    tipOptions: tipOptions, tipAskDefault: tipAskDefault, staffCount: staffCount, tipRecipient: tipRecipient, tipClaim: tipClaim,
  };
  selftest();
})();
